"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var DEFAULT_OPT = {
  getHref: function getHref(node) {
    return node.data.get("href");
  }
};

function _default(Tag, inlineType) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_OPT;
  return {
    deserialize: function deserialize(el, next) {
      if (inlineType && el.tagName && el.tagName.toLowerCase() === Tag) {
        var data = {};

        if (el.href) {
          data.href = el.href;
        }

        return {
          object: "inline",
          type: inlineType,
          data: data,
          nodes: next(el.childNodes)
        };
      }
    },
    serialize: function serialize(obj, children) {
      if (obj.object == "inline" && obj.type === inlineType) {
        var href = options.getHref(obj);
        var props = {
          href: href
        };
        return _react.default.createElement(Tag, props, children);
      }
    }
  };
}